<template>
    <q-dialog v-model="showModal">
        <q-card style="max-width: 400px;" class="full-width">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-btn class="q-mb-sm" icon="mdi-close" flat round dense v-close-popup />
                    <div class="text-h6 q-mx-auto text-bold q-mb-sm">Multiple License Discounts</div>
                </div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-markup-table>
                    <thead class="text-bold bg-grey-4">
                        <tr>
                            <td>Quantity</td>
                            <td>Discount</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>First License</td>
                            <td>0%</td>
                        </tr>
                        <tr>
                            <td>Licenses 2 - 5</td>
                            <td>10%</td>
                        </tr>
                        <tr>
                            <td>Licenses > 5</td>
                            <td>15%</td>
                        </tr>
                    </tbody>
                </q-markup-table>
                <div>
                    <div class="text-bold q-py-md">Important Terms and Conditions</div>
                    <div class="q-pl-sm" style="font-size: 13px;">
                        <p class="q-mb-none">1. Discounts do not apply to upgrades or subscription renewals. They only apply to new Full licenses.</p>
                        <p class="q-mb-none">2. Discounts cannot be used with any other discounts.</p>
                        <p class="q-mb-none">3. Restricted to licenses purchased by the same company, at the same location.</p>
                        <p class="q-mb-none">4. The discount rates shown apply to the copies in the specified quantity range only, not to the total quantity.</p>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>
<script>

    export default {
        name: 'dialog-multiple-license-discount',
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                }
            },
        },

    }
</script>
